module.exports = "/_next/static/images/kv_mask-373c2e0d1c725ab774efb5817beaa460.png";